import { gray80 } from '../../../colors/gray';
export var MuiDrawer = {
    styleOverrides: {
        paper: {
            backgroundColor: gray80,
        },
    },
};
